<template>
  <div class="container" v-if="fileData.length > 0">
    <div class="header">
      <div class="content">
        <div class="line upload" v-if="resourceEditModeType !== 0">
          <el-button size="small" @click="multipleReduction">全部还原</el-button>
          <el-button size="small" @click="multipleDelete">全部删除</el-button>
        </div>
        <div class="tips">
          <span class="medium general-font">提示：文件保存{{ recycleTime }}天后将被自动删除。</span>
        </div>
        <div class="total-file-number">
          <span class="small main-font">已全部加载，共{{ totalFilesNum }}个文件</span>
        </div>
      </div>
      <el-divider></el-divider>
    </div>
    <div class="main">
      <div class="navigation-bar">
        <div class="steps">
          <span class="small medium">回收站</span>
        </div>
        <div class="catalog-path medium main-font"></div>
        <div class="arrangement">
          <div class="properties">
            <el-dropdown placement="bottom" @command="switchResSortType" :trigger="fromPc === 1 ? 'click' : 'hover'">
              <i class="iconfont icon-positive-sequence mini"></i>
              <el-dropdown-menu slot="dropdown" class="sortTypeDropdown">
                <el-dropdown-item command="name" :class="{'selected':resSortType === 'name'}">文件名</el-dropdown-item>
                <el-dropdown-item command="file_size" :class="{'selected':resSortType === 'file_size'}">大小
                </el-dropdown-item>
                <el-dropdown-item command="file_type" :class="{'selected':resSortType === 'file_type'}">类型
                </el-dropdown-item>
                <el-dropdown-item command="create_time" :class="{'selected':resSortType === 'create_time'}">
                  删除时间
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
<!--            <div class="view-model-div">
              <i id="viewModeSwitchBtn" @click.stop="toggleViewMode"
                 :class="'iconfont ' +(viewMode === 'list' ? 'icon-others-res-card' : 'icon-others-res-list' ) + ' mini'"></i>
            </div>-->
          </div>
        </div>
      </div>
      <div class="content">
        <ResourceTable ref="resourceTable"
                       :parentId="0" :fileData="fileData"
                       :recycleType="true"
                       @refreshFiles="refreshFiles"
                       @resetResSortType="resetResSortType"
                       @changeResEditModeType="changeResEditModeType"
                       @restoreFile="restoreFile"
                       @completeDelete="completeDelete"
                       v-show="viewMode === 'list'"></ResourceTable>
      </div>
    </div>
  </div>
  <div slot="empty" v-else class="empty">
    <div>
      <ResourceEmpty :recycle-type="true" :recycleTime="recycleTime"></ResourceEmpty>
    </div>
  </div>
</template>

<script>
import ResourceTable from "../resource-content/ResourceTable.vue"
import ResourceEmpty from "../resource-content/ResourceEmpty"

let vm
export default {
  name: "recycle",
  components: {
    ResourceTable,
    ResourceEmpty
  },
  beforeCreate() {
    vm = this
  },
  data() {
    return {
      recycleTime: vm.$root.recycleValidTime, // 回收站文件保存天数
      fromPc: sessionStorage.getItem("fromPc"),
      resSortType: 'create_time', // 排序字段
      resSortOrder: 'descending',  // 排序方式
      resourceEditModeType: 0, // 0.正常 1.单选 2.多选
      viewMode: 'list', // 默认展示"详细信息"视图
      fileData: [], // 回收站文件
      totalFilesNum: 0, // 总共文件数量
    };
  },
  mounted() {
    vm.getData()
  },
  methods: {
    // 获取回收站数据列表
    getData() {
      vm.ucloading.showLoading();
      vm.$api.get("/resapi/tw/resource-file-deleted/queryDeletedFiles",{
        params: {
          orderField: vm.resSortType,
          orderType: vm.getOrderType()
        }
      }).then(res => {
        vm.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info)
          return
        }
        vm.totalFilesNum = res.data.length
        vm.fileData = res.data
      }).catch(error => {
        vm.ucloading.hideLoading();
        console.error(error)
      })
    },
    // 排序查询开始
    refreshFiles() {
      vm.getData()
    },
    // 全部还原按钮
    multipleReduction() {
      this.$refs.resourceTable.multipleReduction()
    },
    // 全部删除按钮
    multipleDelete() {
      this.$refs.resourceTable.multipleDeleteRecycle()
    },
    // 右上角下拉框选择排序字段
    switchResSortType(code) {
      let order = 'ascending';
      if (code !== vm.resSortType) {
        order = 'ascending'
      } else {
        order = (vm.resSortOrder === 'descending' ? 'ascending' : 'descending')
      }
      vm.resSortType = code;
      vm.$refs.resourceTable.switchResSortType(code, order)
    },
    // 重置排序字段
    resetResSortType(code, order) {
      this.resSortType = code;
      this.resSortOrder = order;
    },
    // 勾选列表数据(控制头部按钮的展示与隐藏)
    changeResEditModeType(type) {
      this.resourceEditModeType = type;
    },
    // 回收站文件还原
    async restoreFile(ids) {
      const flag = await vm.restoreCheck(ids)
      if(flag) {
        vm.$confirm('还原的位置或还原列表包含同名文件，请选择您的操作：', '保留或跳过文件', {
          distinguishCancelAndClose: true, // 区分取消和关闭
          confirmButtonText: '跳过同名文件',
          cancelButtonText: '保留两个文件'
        }).then(() => {
          vm.restore(ids, '/resapi/tw/resource-file-deleted/restore')
        }).catch(action => {
          console.log(action)
          if(action === 'cancel') {
            vm.restore(ids, '/resapi/tw/resource-file-deleted/restoreRepeat')
          }
        })
      }else {
        vm.restore(ids, '/resapi/tw/resource-file-deleted/restore')
      }
    },
    // 检查待还原文件是否在网盘中存在
    restoreCheck(ids) {
      return new Promise(resolve => {
        vm.ucloading.showLoading()
        vm.$api.post('/resapi/tw/resource-file-deleted/restoreCheck', {
          fileIds: ids
        }).then(res => {
          if(res.success) {
            resolve(res.data)
            return
          }
          vm.$message.error(res.info)
        }).catch(err => {
          console.error(err)
          //vm.$message.error(err)
        }).finally(() => {
          vm.ucloading.hideLoading()
        })
      })
    },
    // 还原操作
    restore(ids, url) {
      vm.ucloading.showLoading()
      vm.$api.post(url, {
        fileIds: ids
      }).then(res => {
        if(res.success && res.data.taskId) {
          vm.timeOutQueryOperateStatus(res.data.taskId, 2);
          return
        }
        vm.ucloading.hideLoading()
        vm.$message.error(res.info)
      }).catch(err => {
        console.error(err)
        vm.ucloading.hideLoading()
      })
    },
    // 永久删除回收站文件
    completeDelete(ids) {
      vm.ucloading.showLoading()
      vm.$api.post('/resapi/tw/resource-file-deleted/completeDel', {
        fileIds: ids
      }).then(res => {
        if(res.success && res.data.taskId) {
          vm.timeOutQueryOperateStatus(res.data.taskId, 1);
          return
        }
        vm.ucloading.hideLoading()
        vm.$message.error(res.info)
      }).catch(err => {
        console.error(err)
        vm.ucloading.hideLoading()
      })
    },
    timeOutQueryOperateStatus: function(taskId, type){
      setTimeout(function () {
        vm.queryOperateStatus(taskId, type);
      }, 1000)
    },
    queryOperateStatus(taskId, type){
      vm.$api.post('/resapi/tw/resource-file-deleted/queryOperateStatus', {
        taskId: taskId
      }).then(res => {
        if(res.success) {
          if(res.data.status == 2){
            vm.ucloading.hideLoading()
            if(type == 1){
              vm.$message.success("文件删除成功")
            }else{
              if(res.data.successCount && res.data.successCount > 0) {
                vm.$message.success("文件还原成功")
              }
            }
            vm.getData()
          }else if(res.data.status == 3){
            vm.$message.error(res.data.remark);
            vm.ucloading.hideLoading()
            vm.getData()
          }else{
            vm.timeOutQueryOperateStatus(taskId);
          }
          return;
        }
        vm.ucloading.hideLoading()
        vm.$message.error(res.info)
      }).catch(err => {
        console.error(err)
        vm.ucloading.hideLoading()
      })
    },
    // 获取排序方式(组件的英文字段转数字)
    getOrderType() {
      let orderType = 1
      switch (vm.resSortOrder) {
        case 'descending':
          orderType = 1
          break
        case 'ascending':
          orderType = 0
          break
      }
      return orderType
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin-left: 23px;
  height: 100%;

  .header {
    height: 56px;
    line-height: 56px;
    margin-right: 36px;

    .content {
      position: relative;

      .line {
        display: inline-block;

        &.upload {
          margin: 0 20px 0 12px;
        }
      }

      .tips {
        display: inline-block;
      }

      .total-file-number {
        display: inline-block;
        position: absolute;
        right: 0;
      }
    }
  }

  .main {
    .navigation-bar {
      height: 40px;
      line-height: 40px;
      margin-right: 36px;
      position: relative;

      .steps {
        height: 100%;
        display: inline-block;
        vertical-align: bottom;

        &:hover > i {
          color: #909599 !important;
        }

        i:hover {
          color: #20CCC6 !important;
        }

        .icon-arrow-right {
          margin-left: 14px;
        }
      }

      .catalog-path {
        display: inline-block;
        margin-left: 18px;

        .path {
          display: inline-block;
          cursor: pointer;

          &:hover {
            color: #20CCC6 !important;
          }

          & > i {
            margin: 0 10px 0 8px;
            color: #909599 !important;
          }
        }
      }

      .arrangement {
        display: inline-block;
        position: absolute;
        right: 25px;
      }
    }

    .content {
      height: calc(100% - 40px);

      .title {
        height: 41px;
        line-height: 41px;
        margin-right: 36px;

        .file-param {
          display: inline-block;
        }

        .file-name {
          margin-left: 7px;
          width: 42.4%;

          & span {
            margin-left: 25px;
          }
        }
      }
    }
  }
}

.empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -3vh;
}
</style>
